import { z } from 'zod'

/**
 * Category of a file attached to an event. Mirrors the `EventDocumentKind` enum
 * in the Prisma schema — keep the two in sync.
 */
export const EVENT_DOCUMENT_KINDS = [
  'beo',
  'contract',
  'proposal',
  'floorplan',
  'timeline',
  'other',
] as const

export const eventDocumentKindSchema = z.enum(EVENT_DOCUMENT_KINDS)

export type EventDocumentKind = z.infer<typeof eventDocumentKindSchema>
